import { z } from "zod";

/**
 * User info light schema (for audit / note author references).
 * OpenAPI `UserInfoLight` — shared across jobs, assets, tickets, etc.
 */
export const UserInfoLightSchema = z.object({
	id: z.string().uuid().nullable().optional(),
	hasAvatar: z.boolean().optional(),
	displayName: z.string().nullable().optional(),
	email: z.string().nullable().optional(),
	firstName: z.string().nullable().optional(),
	middleName: z.string().nullable().optional(),
	lastName: z.string().nullable().optional(),
});

export type UserInfoLight = z.infer<typeof UserInfoLightSchema>;
